<mat-form-field [ngClass]="{ 'w-100': true, mgn: control?.isReadonly }">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <input
    matInput
    autocomplete="off"
    [formControl]="control"
    [placeholder]="control?.caption | translate"
    [required]="control?.required ? true : null"
    [readonly]="control?.isReadonly ? true : null"
    [ngClass]="{ locked: control?.isReadonly }"
    (blur)="onblur()"
    (focus)="onfocus()"
    [class.text-center]="textAlignCenter"
    #input
    />
    @if (errorMessage) {
      <mat-error>{{ errorMessage?.message | translate: errorMessage?.params }}</mat-error>
    }
  </mat-form-field>

  <!-- Controls (on :hover) -->
  <div class="_controls">
    <!-- clear other form fields (except this) -->
    @if (showClearOthers) {
      <div class="_control _control__clear-others" (click)="addonClicked()"></div>
    }
    <!-- clear this field -->
    @if (showClearThis) {
      <div class="_control _control__clear-this" (click)="clearBtnClicked()">&#10005;</div>
    }
    <!-- phone -->
    @if (fieldType == 'phone') {
      <a class="_control _control__call-number" href="tel:{{ control?.value }}"></a>
    }
    <!-- send email -->
    @if (fieldType == 'email') {
      <a class="_control _control__send-email" (click)="sendEmail()"></a>
    }
  </div>

  <!--
  @if (showClearOthers) {
    <div class="addon" (click)="addonClicked()" (mouseenter)="onAddonMouseEnter()" (mouseleave)="onAddonMouseLeave()">
      @if (showAddonHelp) {
        <div class="help-text-container">
          <p class="help-text">
            {{ 'COMMON.CLEAR_OTHER_FILTERS' | translate }}
          </p>
        </div>
      }
    </div>
  }
  -->
